import React from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer id="contact" className="relative">
      <div className="section-divider"></div>

      <div className="container mx-auto px-6 py-16">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-12">
            {/* Left side */}
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 border border-[#00ffd5]/30 flex items-center justify-center">
                <div className="w-1.5 h-1.5 bg-[#00ffd5]"></div>
              </div>
              <div>
                <div className="font-mono text-sm font-semibold tracking-[0.2em] text-white/80 uppercase">
                  COZMOZ AI
                </div>
                <p className="font-mono text-[0.6rem] text-white/40 tracking-wider">
                  Autonomous Mobile Security
                </p>
              </div>
            </div>

            {/* Right side - Social */}
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/in/mahima246"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/[0.06] text-white/25 hover:text-[#00ffd5] hover:border-[#00ffd5]/30 transition-all"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-3.5 h-3.5" />
              </a>
              <a
                href="https://twitter.com/MahimaaAurora"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/[0.06] text-white/25 hover:text-[#00ffd5] hover:border-[#00ffd5]/30 transition-all"
                aria-label="Twitter"
              >
                <Twitter className="w-3.5 h-3.5" />
              </a>
              <a
                href="mailto:mahima@cozmoz.ai"
                className="w-9 h-9 flex items-center justify-center border border-white/[0.06] text-white/25 hover:text-[#00ffd5] hover:border-[#00ffd5]/30 transition-all"
                aria-label="Email"
              >
                <Mail className="w-3.5 h-3.5" />
              </a>
            </div>
          </div>

          {/* Bottom */}
          <div className="pt-8 border-t border-white/[0.04] flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-mono text-[0.65rem] text-white/30 tracking-wider">
              &copy; {new Date().getFullYear()} COZMOZ AI. ALL RIGHTS RESERVED.
            </p>
            <p className="font-mono text-[0.6rem] text-white/25 tracking-wider">
              SAN FRANCISCO, CA
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
